import type {ExtendedLastUpdate} from '@domain/material-demand'
import {ForecastUpdatedVia} from '@domain/material-demand'
import {formatTons} from '@hconnect/uikit/src/common'
import {dataTestId} from '@hconnect/uikit/src/common/utils/testingUtils'
import {useUpmPlantTimezone} from '@hconnect/upm'
import {Typography, Stack} from '@mui/material'
import moment from 'moment-timezone'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../../consts'
import {getLocalizedDayMonthTimeFormat} from '../../utils'

type TMaterialDemandTableFieldTooltipContentParams = {
  // allowing undefined for not forecasted materials
  predicted: number | undefined
  lastUpdate: ExtendedLastUpdate
}

export function MaterialDemandTableFieldTooltipContent({
  predicted,
  lastUpdate: {updatedOn, updatedBy, updatedVia}
}: TMaterialDemandTableFieldTooltipContentParams) {
  const {
    t,
    i18n: {language}
  } = useTranslation(FEATURE_NAMESPACE)
  const timezoneId = useUpmPlantTimezone()

  const formatUpdatedOn = (updatedOn: string) =>
    getLocalizedDayMonthTimeFormat(moment.utc(updatedOn), timezoneId, language)

  return (
    <Stack spacing={1} {...dataTestId('forecast_override_info_tootip')}>
      <Typography variant="body1">
        {t(
          updatedVia === ForecastUpdatedVia.User
            ? 'demand.valueHasBeenEditedManually'
            : 'demand.valueHasBeenEditedByMail'
        )}
      </Typography>
      {predicted !== undefined && (
        <Typography variant="body2">
          {t('demand.originalForecastedValue', {value: formatTons(predicted, language)})}
        </Typography>
      )}
      {updatedOn && (
        <Typography variant="body2">
          {t('demand.updatedOn', {updatedOn: formatUpdatedOn(updatedOn)})}
        </Typography>
      )}
      {updatedBy && <Typography variant="body2">{t('demand.updatedBy', {updatedBy})}</Typography>}
    </Stack>
  )
}
